import React from "react";
import "./NavL.css";
import { FaTiktok } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { useLocation } from "react-router-dom";

function NavL() {
  let location = useLocation();
  
  return (
   <>
      {
    location.pathname === "/armatupc" ?
    null
    :
    <ul className="navl">
      <li className="li-n">
        <a href="https://www.tiktok.com/@laconsola.digital">
          <FaTiktok></FaTiktok>
        </a>
        <br></br>
        <a href="https://www.instagram.com/laconsola.dig/">
          <FaInstagram></FaInstagram>
        </a>
        <br></br>
        <a href="https://www.facebook.com/laconsola.dig">
          <FaFacebook></FaFacebook>
        </a>
      </li>
  </ul>
    }
   </>
  );
}
export default NavL;
